module.exports = __webpack_public_path__ + "static/media/marker-so.2487f277.svg";